import { CoverLetterForm } from "components";

const CoverLetter = () => {
  return (
    <div>
      <h1 className="title">Cover Letter</h1>
      <CoverLetterForm />
    </div>
  );
};

export default CoverLetter;
